<template>
    <card-list-item @action="action" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fas fa-circle fa-fw text-success"></i>
        </template>
        <template v-slot:content>
            <div class="subject">{{ticket.subject}}</div>
        </template>
        <template v-slot:status>
            <div class="date">Jul 25, 2020, 3:45pm</div>
        </template>
        <template v-slot:details>
            <p class="preview">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua..</p>

            <toolbar class="toolbar">
                <button class="icon-only" v-b-tooltip.hover title="Reply" @click.stop=""><i class="far fa-reply"></i></button>
                <button class="icon-only" v-b-tooltip.hover title="Mark Resolved" @click.stop=""><i class="far fa-check"></i></button>
                <button class="icon-only" v-b-tooltip.hover title="Archive" @click.stop=""><i class="far fa-archive"></i></button>
                <button class="icon-only" v-b-tooltip.hover title="View User" @click.stop=""><i class="far fa-address-card"></i></button>
            </toolbar>

            <div class="data mt-1">
                <data-row mini title="ID">{{ticket.id}}</data-row>
                <data-row mini title="ID">{{ticket.email2}}</data-row>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "./common/Toolbar";
    import DataRow from "./common/DataRow";
    import CardListItem from "./common/CardListItem";

    export default {
        name: 'SupportTicketListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            active: {}
        },
        data: function () {
            return {
                details: false,
                ticket: {
                    subject: '50 hour reflection summary for Reflecting on and Evaluating Physical Education/Health and Fitness Curriculum and Instruction (C30527, 50 hours)'
                }
            }
        },
        methods: {
            action: function () {
                this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        padding: 0.6rem 0;

        .subject {
            font-size: 0.8rem;
            line-height: normal;
            padding-top: 2px;
            font-weight: bold
        }

        .date {
            font-size: 0.75rem;
        }

        .preview {
            font-size: 12px;
        }

        i.fa-circle {
            font-size: 0.4rem;
            vertical-align: 30%;
        }
    }

</style>
